export const gameSettings = {
  designWidth: 1920,
  designHeight: 1080,
  backgroundColor: '#10140b',
  maxPointers: 10,
  kiosk: {
    targetDiagonalInches: 50,
    aspectRatio: '16:9',
    safeMargin: 64,
    minTouchTarget: 128,
    characterHeight: 620,
    reactionTargetSize: 244,
  },
  touch: {
    dragThreshold: 24,
    tapMaxDurationMs: 260,
  },
  animation: {
    headLookRange: 16,
    pupilLookRange: 10,
    blinkMinDelayMs: 1800,
    blinkMaxDelayMs: 3600,
    idleFloatY: 16,
  },
  feedback: {
    cameraPulseZoom: 1.018,
    cameraShakeIntensity: 0.0018,
    orbRewardEnergy: 12,
    tapEnergy: 3,
  },
  gameplay: {
    durationSeconds: 30,
    maxHairTouches: 3,
    scorePerFlea: 1,
    hairPenalty: 1,
    fleaSpawnStartMs: 720,
    fleaSpawnEndMs: 360,
    initialFleaSpeed: 185,
    finalFleaSpeed: 470,
    tickBoss: {
      appearsWithRemainingMs: 10_000,
      health: 2,
      miniTicks: 8,
      miniTickScore: 2,
      miniTickLifetimeMs: 8_500,
      timeBonusesSeconds: [5, 10],
      lifeBonuses: 2,
    },
    frenzy: {
      baseKills: 10,
      windowMs: 15_000,
      baseDurationMs: 4_500,
      extraDurationPerKillMs: 550,
      maxDurationMs: 12_000,
      scoreMultiplier: 2,
      spawnDelayMultiplier: 0.62,
      killsPerLevel: 4,
      maxLevel: 5,
    },
  },
} as const;
